var map = {
	"./ailos.png": "d49b",
	"./bb.png": "59be",
	"./bradesco.png": "fabc",
	"./c6.png": "6637",
	"./caixa.png": "52b3",
	"./inter.png": "ce8f",
	"./itau.png": "6548",
	"./modal.png": "d90a",
	"./mp.png": "5208",
	"./nubank.png": "6dd2",
	"./santander.png": "9241"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be13";